export const getDisplayFileName = (fileName: string) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    const name = fileName.slice(0, lastDotIndex);
    const extension = fileName.slice(lastDotIndex);
    const truncatedName = name.length > 5 ? name.slice(0, 5) + '..' : name;
    return truncatedName + extension;
};

export const getDisplayLinkName = (linkName: string) => {
    return linkName.length > 15 ? `${linkName.slice(0, 12)}...` : linkName;
}

export const getDisplayCodeFileName = (codeFileName: string) => {
    return codeFileName.length > 28 ? `...${codeFileName.slice(-26)}` : codeFileName;
}
